'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./tracking/tracking'));

    $('#rut-input').on('keypress', function(event){
        return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode === 75 || event.charCode === 107) || (event.charCode === 45);
    });
});